import { render } from "./NavBarWeb.vue?vue&type=template&id=677649c8&scoped=true"
import script from "./NavBarWeb.vue?vue&type=script&lang=js"
export * from "./NavBarWeb.vue?vue&type=script&lang=js"

import "./NavBarWeb.vue?vue&type=style&index=0&id=677649c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677649c8"]])

export default __exports__